import React from 'react';
import Sidebar from './sidebar';
import FooterStyle from './footer';
import { Link } from 'react-router-dom';
// import CustomCarousel from './carousel';





export const AboutPage = () => {

  // const carouselContent = [
  //   { imageUrl: './images/careerpage4.jpg' },
  //   { imageUrl: './images/careerpage2.jpg' },
  //   { imageUrl: './images/careerpage.jpg' },
  //   { imageUrl: './images/careerpage3.jpg' },
  // ];

  return (
    <div className='top-layout'>
      <div className='Navbar'>
        <Sidebar />
      </div>
    
      <div className='layout'>

      <div className='KS-logo'>
          <Link to="/" style={{ position:'absolute', cursor: 'pointer', zIndex: '100'}}>
            <img src={process.env.PUBLIC_URL + '/images/KS_logo.png'} alt="Logo" style={{ width: '4.5rem', marginTop:'0.3rem'}} />
          </Link>
        </div>

        {/* <div className='backgroundVideo' style={{ height: '60vh', overflow:'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
          <video autoPlay loop muted id='video' style={{ width: '100%', height: 'auto'}}>
            <source src={process.env.PUBLIC_URL + '/videos/ams-final.mp4'} type="video/mp4" />
          </video>
          <h1 style={{ position: 'absolute', color:'#ffba03', left:'3rem', bottom:'0', fontSize:'4rem', fontWeight:'700', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)' }}>WHO WE ARE</h1>
          <div className="video-overlay" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 186, 3, 0.2)' }}></div>
        </div> */}

        <div className='backgroundImage' style={{ boxShadow:'none'}}>
          {/* <img src={process.env.PUBLIC_URL + '/images/20190114_102247.jpg'} alt="headImage" style={{ width: '100%', position:'relative' }} />   */}
          <img src={process.env.PUBLIC_URL + '/images/intro-bg.jpg'} alt="headImage" style={{ width: '100%', position:'relative' }} />  
          <h1>WHO ARE WE</h1>
        </div>

        <div className='about-content-1'>
          <div className='about-content-1-1'>
            <h2 style={{ color:'#ffba03'}}>Who are we?</h2>
            <ul>
              <li>KSSB, or Kombinasi Saudagar Sdn Bhd:</li>
              <ul>
                <li>Premier provider of comprehensive asset management solutions</li>
                <li>Specializes in meticulous care and maintenance of high-value assets</li>
                <li>Expertise in asset management, particularly focused on buildings</li>
              </ul>
            </ul>
            <ul>
              <li>Wealth of experience:</li>
              <ul>
                <li>Diligently catering to the diverse requirements of esteemed clientele</li>
                <li>Clients from both local and international arenas</li>
                <li>Extensive track record demonstrating commitment to excellence</li>
                <li>Unwavering dedication to meeting and exceeding client expectations</li>
              </ul>
            </ul>
          </div>
          <div className='about-content-1-1-video'style={{ width:'50%', overflow:'hidden', display:'flex', flexDirection:'column', padding:'0 0 0 1rem'}}>
            <video autoPlay loop muted id='video' style={{ width: '100%', height: 'auto'}}>
              <source src={process.env.PUBLIC_URL + '/videos/ams-final.mp4'} type="video/mp4" />
            </video>
          </div>
        </div>


        <div className='contactwidget'>
            <div>
              <h2>Total Asset Management Solutions Provider</h2>
              <p>Get started today and complete our form to get in touch with us</p>
            </div>
            <div>
              <Link to='/contact'>
                <button>Contact us</button>
              </Link>
            </div>
        </div>


        <div className='about-content-2'>
          <div className='about-content-2-2'>
            <h2 style={{ color:'#ffba03'}}>"Pioneering Asset Management Across Sabah"</h2>
              <ul>
                <li>Entire state of Sabah, ensuring accessible top-notch services throughout the region</li>
                <li>Extending our reach and bringing high standards of asset management to Malaysia's bustling capital:</li>
                <ul>
                  <li>Bespoke Hotel Puchong</li>
                  <li>Swiss Wellness Center, Kuala Lumpur</li>
                </ul>
              </ul> 
          </div>
          <div className='about-content-2-2-image'>
            <img src={process.env.PUBLIC_URL + '/images/sabah_map_oct2022-01.webp'} alt="headImage" style={{ width: '70%' }} />
          </div>
        </div>
        
        
        <div className='footer'>
          <FooterStyle />
        </div>

      </div>
    </div>
  );
}

export default AboutPage;
